import React from "react"
import { useGlobalState } from "../contexts/GlobalStateContext"
import { useCert } from "../contexts/CertificatesContext"

const CertificateCommunication = ({ date, fillTime }) => {
    const { t, valuesComm } = useGlobalState()
    const { Header, MainText, Footer } = useCert()
    const valuesLongSide = []
    const valuesShortSide = []
    let time = new Date(fillTime ? fillTime : 0).toISOString().substr(11, 8)
    const size_comm = 600

    let i = 0;
    for (var key in valuesComm) {
        if (i > 0 && i < 5) {
            valuesLongSide[key] = size_comm * 0.5 + valuesComm[key] * 19 /* scaling and positioning */
        } else {
            valuesLongSide[key] = size_comm * 0.5 - valuesComm[key] * 19; /* scaling and positioning */
        }

        if (i === 0 || i === 2 || i === 3 || i === 5) {
            valuesShortSide[key] = size_comm * 0.5 + valuesComm[key] * 19 /* scaling and positioning */ * 0.414; /* to form an octagon, one of the values per point must be changed by * 0.414 */
        } else {
            valuesShortSide[key] = size_comm * 0.5 - valuesComm[key] * 19 /* scaling and positioning */ * 0.414; /* to form an octagon, one of the values per point must be changed by * 0.414 */
        }
        i++;
    }

    const ShowValues = () => {
        let keys = ['value_a', 'value_b', 'value_c', 'value_d', 'value_e', 'value_f', 'value_g', 'value_h'];
        let content = [];
        let l = 8;
        for (let r = 0; r < 4; r++) {
            l--;
            content.push(
                <div id={'divComm' + r} key={'divComm' + r} className='text-center'>
                    <h6 id={'comm' + l} className='comm'>{valuesComm[keys[l]]}</h6>
                    <h6 id={'comm' + r} className='comm'>{valuesComm[keys[r]]}</h6>
                </div>
            )
        }
        return content;
    }

    return (
        Object.keys(valuesComm).length > 0 &&
        <div id="certComm" className={'cert d-flex flex-column'} style={{ backgroundColor: `#fff` }}>
            <Header />
            <div id='main-cert' className={'d-flex flex-column align-items-center text-center'}>
                <MainText time={time} date={date} strAssessment={'comm'} />
                <div id='value-container' className='position-relative'>
                    <ShowValues />
                </div>
                <div className='diagram-container backgroundComm'>
                    <svg id='circleComm' width="577" height="577"></svg>
                    <img src={t('App.lang') === 'de' ? process.env.PUBLIC_URL + '/images/de/de.comm.png' : process.env.PUBLIC_URL + '/images/en/en.comm.png'} width={size_comm} height={size_comm} alt='comm.png' className='position-absolute' />
                    <svg width="600" height="600">
                        <polygon id="polygonComm" style={{ fill: 'none', stroke: '#000', strokeWidth: '2px' }} points={valuesShortSide['value_a'] + "," + valuesLongSide['value_a'] + " " + valuesLongSide['value_b'] + "," + valuesShortSide['value_b'] + " " + valuesLongSide['value_c'] + "," + valuesShortSide['value_c'] + " " + valuesShortSide['value_d'] + "," + valuesLongSide['value_d'] + " " + valuesShortSide['value_e'] + "," + valuesLongSide['value_e'] + " " + valuesLongSide['value_f'] + "," + valuesShortSide['value_f'] + " " + valuesLongSide['value_g'] + "," + valuesShortSide['value_g'] + " " + valuesShortSide['value_h'] + "," + valuesLongSide['value_h']} />
                    </svg>
                </div>
            </div>
            <Footer strAssessment={'comm'} />
        </div>
    )
}

export default CertificateCommunication
